<template>
  <div>
    <Banner />
    <div class="user-content">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="已报考" name="has">
          <el-table
            v-loading="loading"
            :data="hasSignExam"
            style="width: 100%">
            <el-table-column label="报名项目">
              <template slot-scope="scope">
                <div class="exam-name">{{ scope.row.examName }}</div>
                <el-popover
                  width="300"
                  trigger="hover"
                  :content="scope.row.description">
                  <div slot="reference" class="exam-description">{{ scope.row.description }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="报名状态" width="150">
              <template slot-scope="scope">
                <el-button :type="scope.row.examStatus | filterStatusType" size="small">{{ scope.row.examStatus | filterStatusText }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="380">
              <template slot-scope="scope">
                <el-button v-if="scope.row.faceStatus" type="primary" size="small" plain @click="signForm('interview', scope.row.examineeId)">面试准考证</el-button>
                <template v-else>
                  <el-button v-if="scope.row.writtenStatus" type="primary" size="small" plain @click="signForm('written', scope.row.examineeId)">笔试准考证</el-button>
                  <el-button v-else-if="scope.row.examStatus !== -2" type="primary" size="small" plain @click="signForm('sign', scope.row.examineeId)">报名表</el-button>
                </template>
                <el-button v-if="scope.row.writtenStatus" type="primary" size="small" plain @click="checkResult(scope.row.examineeId)">成绩查询</el-button>
                <el-popover
                  v-if="scope.row.examStatus === -1"
                  title="原因："
                  width="200"
                  trigger="click"
                  :content="scope.row.reason"
                  style="margin: 0 10px">
                  <el-button size="small" slot="reference">不通过原因</el-button>
                </el-popover>
                <el-button v-if="scope.row.examStatus === -1" type="primary" size="small" plain @click="editForm(scope.row)">修改填报</el-button>
                <el-button v-if="scope.row.examStatus === -1" type="primary" size="small" plain @click="cancelSign(scope.row)">取消报名</el-button>
                <el-button v-if="scope.row.examStatus === 2 && scope.row.payStatus" type="success" size="small" plain @click="getOrderId(scope.row)">支付报名费</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="正在报考" name="open">
          <el-table
            v-loading="loading"
            :data="openSignExam"
            style="width: 100%">
            <el-table-column label="报名项目">
              <template slot-scope="scope">
                <el-link type="primary" :href="'#/examDetail?id=' + scope.row.id">{{ scope.row.examName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <div>{{ scope.row.signupBeginTime }}开始</div>
                <div>{{ scope.row.signupEndTime }}结束</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left">
              <template slot-scope="scope">
                <el-button type="primary" size="small" plain @click="examDetail(scope.row.id)">立即报名</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="请扫码支付报名费"
        :visible.sync="payDialog"
        :close-on-click-modal="false"
        width="500px"
        center
        @close="closeDialog">
        <div class="pay-content">
          <el-image :src="payCodeUrl" fit="fill" class="pay-image"></el-image>
          <div class="refresh-mask" v-if="lastSecond <= 0">
            <el-button type="primary" @click="refreshCode">重新获取二维码</el-button>
          </div>
          <p v-else>距离二维码过期还剩<span class="last-second">{{lastSecond}}</span>秒</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="payFinished">已支付</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="成绩单"
        :visible.sync="examResultDialog"
        :close-on-click-modal="false"
        width="400px"
        center
        @close="examResultDialog = false">
        <div class="result-content">
          <el-row class="result-row">
            <el-col :span="12" class="result-name">笔试成绩</el-col>
            <el-col :span="12">{{ examResult.writeScore ? examResult.writeScore : '暂无' }}</el-col>
          </el-row>
          <el-row class="result-row">
            <el-col :span="12" class="result-name">笔试排名</el-col>
            <el-col :span="12">{{ examResult.writeRank ? examResult.writeRank : '暂无' }}</el-col>
          </el-row>
          <el-row class="result-row">
            <el-col :span="12" class="result-name">是否进入面试</el-col>
            <el-col :span="12">{{ examResult.writeStatus === 2 ? '是' : '否' }}</el-col>
          </el-row>
          <el-row class="result-row">
            <el-col :span="12" class="result-name">面试成绩</el-col>
            <el-col :span="12">{{ examResult.faceScore ? examResult.faceScore : '暂无' }}</el-col>
          </el-row>
          <el-row class="result-row">
            <el-col :span="12" class="result-name">面试排名</el-col>
            <el-col :span="12">{{ examResult.faceRank ? examResult.faceRank : '暂无' }}</el-col>
          </el-row>
          <el-row class="result-row">
            <el-col :span="12" class="result-name">是否录用</el-col>
            <el-col :span="12">{{ examResult.faceStatus === 5 ? '是' : '否' }}</el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="examResultDialog = false">关闭</el-button>
        </span>
      </el-dialog>
      <SignForm ref="signForm" />
    </div>
  </div>
</template>

<script>
import { getSignExam, judgeEditForm } from '@/api/user'
import { homeExam, createOrder, getOrderCode, getPayStatus, getExamResult, cancenExamSign } from '@/api/exam'
import SignForm from './components/SignForm'
import Banner from '../layout/components/Banner'

export default {
  name: 'User',
  components: {
    SignForm,
    Banner
  },
  data() {
    return {
      loading: false,
      activeTab: 'has',
      hasSignExam: [],
      openSignExam: [],
      operateObj: null,
      payDialog: false,
      timer: null,
      lastSecond: 60,
      orderId: '',
      payCodeUrl: '',
      examResultDialog: false,
      examResult: {}
    }
  },
  filters: {
    filterStatusText(value) {
      switch(value) {
        case -2:
          return '已取消'
        case -1:
          return '不通过'
        case 1:
          return '审核中'
        case 2:
          return '审核通过'
        case 3:
          return '未缴费'
        case 4:
          return '已缴费'
      }
    },
    filterStatusType(value) {
      let successArr = [2, 4]
      let infoArr = [1, 3]
      let dangerArr = [-1, -2]
      if (successArr.indexOf(value) !== -1) {
        return 'success'
      } else if (infoArr.indexOf(value) !== -1) {
        return 'warning'
      } else if (dangerArr.indexOf(value) !== -1) {
        return 'danger'
      }
    }
  },
  mounted() {
    this.getHasSignData()
  },
  methods: {
    getHasSignData() {
      this.loading = true
      this.hasSignExam = []
      getSignExam()
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.hasSignExam = res.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getOpenSignData() {
      this.loading = true
      this.openSignExam = []
      homeExam()
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.openSignExam = res.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleClick() {
      if (this.activeTab === 'has') {
        this.getHasSignData()
      } else if (this.activeTab === 'open') {
        this.getOpenSignData()
      }
    },
    examDetail(id) {
      this.$router.push('/examDetail?id=' + id)
    },
    signForm(type, id) {
      this.$refs.signForm.init(type, id)
    },
    cancelSign(obj) {
      cancenExamSign(obj.examineeId)
        .then(() => {
          this.getHasSignData()
        })
    },
    checkResult(id) {
      getExamResult(id)
        .then(res => {
          this.examResult = {}
          if (res.data.status === 0) {
            this.$notify({
              title: '未查询到成绩',
              message: '请稍后再查询',
              type: 'info',
              duration: 2000
            })
          } else if (res.data.status === 1) {
            this.examResult = res.data
            this.examResultDialog = true
          }
        })
    },
    editForm(obj) {
      judgeEditForm(obj.examineeId)
        .then(res => {
          if (res.data.status) {
            this.$router.push('/signUp?examId=' + obj.examId + '&jobId=' + obj.jobId + '&examineeId=' + obj.examineeId)
          } else {
            this.$message.error('修改次数超限，不可修改')
          }
        })
    },
    refreshCode() {
      this.getOrderId(this.operateObj)
    },
    getOrderId(obj) {
      this.loading = true
      this.operateObj = Object.assign({}, obj)
      let that = this
      this.payCodeUrl = ''
      createOrder({
        examineeId: obj.examineeId,
        type: 0
      })
        .then(res => {
          if (res.code === 200) {
            this.orderId = res.data.orderNo
            let lastTime = res.data.expireTime - new Date().getTime()
            this.lastSecond = Math.floor(lastTime / 1000)
            this.timer = setInterval(function() {
              that.lastSecond--
              if (that.lastSecond <=0) {
                clearInterval(that.timer)
              }
            }, 1000)
            this.getCodeUrl()
          } else {
            this.loading = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getCodeUrl() {
      getOrderCode({
        orderNo: this.orderId
      })
        .then(res => {
          let blob = new Blob([res], {type: 'image/jpeg'})
          this.payCodeUrl = window.URL.createObjectURL(blob)
          this.payDialog = true
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    payFinished() {
      getPayStatus({
        orderNo: this.orderId
      })
        .then(res => {
          if (res.code === 200) {
            if (res.data.payStatus) {
              this.$message.success('支付成功')
              this.payDialog = false
              this.lastSecond = 60
              this.timer = null
              this.payCodeUrl = ''
              this.getHasSignData()
            } else {
              this.$message.warning('未检测到支付状态，请稍后重试')
            }
          }
        })
    },
    closeDialog() {
      this.payCodeUrl = ''
      clearInterval(this.timer)
      this.lastSecond = 60
    }
  }
}
</script>

<style lang="scss" scoped>
.user-content {
  max-width: 1200px;
  background: #fff;
  border-radius: 4px;
  margin: 30px auto;
  padding: 10px 24px;
  .exam-name {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
  .exam-description {
    color: #606266;
    font-size: 12px;
    max-width: 460px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.pay-content {
  text-align: center;
  position: relative;
  width: 200px;
  margin: 0 auto;
  .pay-image {
    width: 200px;
    height: 200px;
  }
  .refresh-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .last-second {
    color: red;
  }
}
.result-content {
  border: 1px solid #ccc;
  .result-row {
    border-bottom: 1px solid #ccc;
    line-height: 36px;
    .result-name {
      border-right: 1px solid #ccc;
      text-align: left;
      padding-left: 20px;
      font-weight: 600;
    }
    div {
      text-align: center;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
